module.exports = __webpack_public_path__ + "img/home_page_welcome_billboard.png";